import { EventTagsEditor } from '../../tixologist/TagsSection/EventTagsEditor/EventTagsEditor';

export const TagsSection = () => <EventTagsEditor />;
